const onEventClickHandler = ({ analytics, event, onClick }) => {
    analytics?.onClickTracking?.(event);
    onClick?.(event);
};
const ButtonHandlers = (props) => ({
    onEventClick: event => onEventClickHandler({ ...props, event }),
});
export { ButtonHandlers };
//# sourceMappingURL=button.handlers.js.map